import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Type is required!"),
  amenity_images: Yup.string().required("Image is required!"),
  description: Yup.string().required("Description is required!"),
  terms_and_condition: Yup.string().required("Terms and condition is required!"),
  is_active: Yup.string().required("Status is required!"),
  amenity_occasion_prices: Yup.array().of(
    Yup.object().shape({
      occasion_id: Yup.number().nullable().required("Occasion is required!"),
      member_price: Yup.number()
        .typeError("Must be a number")
        .required("Member price is required!"),
      non_member_price: Yup.number()
        .typeError("Must be a number")
        .required("Non-member price is required!"),
    })
  ),
});
